import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getTimeClockDay(workDate, token) {
  const params = {};
  if (workDate) params.work_date = workDate;
  const res = await axios.get(`${API}/time-clocks/day`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listOpenTimeClocks(token) {
  const res = await axios.get(`${API}/time-clocks/open`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function clockIn(staffId, workDate, token) {
  const params = {};
  if (workDate) params.work_date = workDate;
  const res = await axios.post(
    `${API}/time-clocks/${staffId}/clock-in`,
    {},
    {
      params,
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function clockOut(staffId, workDate, token) {
  const params = {};
  if (workDate) params.work_date = workDate;
  const res = await axios.post(
    `${API}/time-clocks/${staffId}/clock-out`,
    {},
    {
      params,
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateTimeClockEntry(entryId, payload, token) {
  const res = await axios.put(
    `${API}/time-clocks/${entryId}`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function upsertTimeClockEntry(staffId, payload, token) {
  const res = await axios.post(
    `${API}/time-clocks/${staffId}/entry`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function deleteTimeClockEntry(entryId, token) {
  const res = await axios.delete(`${API}/time-clocks/${entryId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}
